import TheCogs from './TheCogs'
import TheClock from './TheClock'
import TheCrates from './TheCrates'
import SwitchesPassword from './theSwitches/SwitchesPassword'
import TheSwitches from './theSwitches/TheSwitches'
import TheFlags from './theFlags/TheFlags'
import FlagsPassword from './theFlags/FlagsPassword'
import TheToolbox from './TheToolbox'
import TheLockedDoor from './TheLockedDoor'

import clockProcess from '../../../../images/clues/lastStand/clockProcess.png'
import switchesSolution from '../../../../images/clues/lastStand/switchesSolution.png'

const lastStandData = [
    {
        name: 'The Cogs',
        id: 'cogs',
        sceneText: "The wonders of modern machinery",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <TheCogs />,
        cluesAvailable: false,
        clues: [
            {
                text: 'Those cogs also appear on page 17.'
            },
            {
                text: 'Page 17 gives you the order of the cogs. Can you get one number from each moving cog?'
            },
            {
                text: 'Watch the pattern the first cog traces. Drawing out the same pattern on a piece of paper will give you a number. Do the same for all 4 cogs. The next hint will be the solution',
            },
            {
                text: 'The cogs give you the code: 9524'
            }
        ]
    },
    {
        name: 'The Clock',
        id: 'clock',
        sceneText: "Time waits for no man",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheClock />,
        cluesAvailable: true,
        clues: [
            {
                text: "The clock will give you the password to enter the dock yard office. Find something in the Proffesor's journal which can help."
            },
            {
                text: 'Use the times on page 14 to get a password from the clock.'
            },
            {
                text: 'Each time on page 14 will give you 2 letters on the clock. The next hint will be the solution.',
                image: clockProcess
                
            },
            {
                text: 'The password for the dockyard office is: ALIGNS'
            }
        ]
    },
    {
        name: 'The Crates',
        id: 'crates',
        sceneText: "Precious cargo",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheCrates />,
        cluesAvailable: true,
        clues: [
            {
                text: 'Use pages 1 and 12 to get a 5 digit code from the crates.'
            },
            {
                text: 'Page 1 tells you that each crate belongs to a company. It also translates the crate symbols into numbers. Make sure you are looking at the symbol from the right direction. Pay attention to which way up the crate should be.'
            },
            {
                text: 'Once you have translated each crate into a number using page 1, you can use page 12 to put those numbers in date order. The next hint will be the solution.',
            },
            {
                text: 'The crates give you the code: 86710'
            }
        ]
    },
    {
        name: 'The Control Box',
        id: 'switchesPassword',
        sceneText: "Are you sure you want to mess with the electrics?",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <SwitchesPassword />,
        cluesAvailable: false
    },
    {
        name: 'The Switches',
        id: 'switches',
        sceneText: "A panel to get the power going",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <TheSwitches />,
        cluesAvailable: false,
        clues: [
            {
                text: 'Make sure you have unlocked the dockyard office before attempting this one.'
            },
            {
                text: 'Use the machine in the dockyard office to work out how to set the switches. Page 17 can help.'
            },
            {
                text: 'Page 17 shows you which position is 1 and which position is 0. Watch the dockyard office machine closely, the lights at the top tell you which switch it is showing. The next hint will be the solution.'
            },
            {
                text: 'Set the switches to match this image.',
                image: switchesSolution
            }
        ]
    },
    {
        name: 'The Site Office',
        id: 'flagsPassword',
        sceneText: "The site office is locked",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <FlagsPassword />,
        cluesAvailable: false
    },
    {
        name: 'The Flags',
        id: 'flags',
        sceneText: "The office is open and signals are coming in",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <TheFlags />,
        cluesAvailable: false
    },
    {
        name: 'The Toolbox',
        id: 'toolbox',
        sceneText: "The tools in this toolbox are locked up tight",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheToolbox />,
        cluesAvailable: false
    },
    {
        name: 'The Locked Door',
        id: 'lockedDoor',
        sceneText: "The mechanism is broken, I need a wrench to crank it manually",
        specialIcon: 'fas fa-cogs',
        puzzleVisible: true,
        puzzleLocked: true,
        component: <TheLockedDoor finalPuzzle />,
        cluesAvailable: false,
        clues: [
            {
                text: 'Select the wrench in your inventory and click on the gears icon to use it.'
            }
        ]
    },
    
]

export default lastStandData